import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SvgIcon } from '@material-ui/core';
import { WarningOutline as WarningIcon } from '../../../../components/Icons';
import { useSelector } from 'react-redux';
import { getAlgoListDataCachedSelectedDay } from '../../../../stores/algos-list/getters';
import useBrokerDataAll from '../../../../hooks/useBrokerDataAll';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      fontSize: '1.3rem',
    },

    '&.isError': {
      color: 'var(--color-error-tooltip)',
    },
  },
}));

const checkIfBrokerDisbaled = (val = '', options = []) => {
  const { brokerDisabled = false } =
    options.find((op) => op && op.value && op.value === val) || {};

  return brokerDisabled;
};

function checkBrokerArray(brokers = [], options = []) {
  let disabledBroker = false;

  for (let i = 0; i < brokers.length; i++) {
    const broker = brokers[i];

    const disabled = checkIfBrokerDisbaled(broker, options);

    if (disabled) {
      disabledBroker = true;
      break;
    }
  }

  return disabledBroker;
}

function useIsBrokersDisabled() {
  const uniqueBrokers = [];
  const brokers = useSelector((state) => {
    const broker = getAlgoListDataCachedSelectedDay(state).map(
      (item) => item.broker
    );

    return broker;
  });

  brokers.forEach((broker) => {
    if (!uniqueBrokers.includes(broker)) {
      uniqueBrokers.push(broker);
    }
  });

  const brokersDataAll = useBrokerDataAll();

  const brokerDisabled = checkBrokerArray(uniqueBrokers, brokersDataAll);

  return brokerDisabled;
}

function useIsError() {
  const hasError = useSelector((state) => {
    const some = getAlgoListDataCachedSelectedDay(state).some(
      (item) => item.hasError
    );

    return some;
  });

  const hasWaitingWT = useSelector((state) => {
    const some = getAlgoListDataCachedSelectedDay(state).some(
      (item) => item.hasWaitingWT
    );

    return some;
  });

  const stoplossTrailing = useSelector((state) => {
    const some = getAlgoListDataCachedSelectedDay(state).some(
      (item) => item.stoplossTrailing
    );

    return some;
  });

  const brokersDisabled = useIsBrokersDisabled();

  if (hasError || hasWaitingWT || stoplossTrailing || brokersDisabled) {
    return true;
  }

  return false;
}

const HeadCellAlerts = () => {
  const classes = useStyles();
  const isError = useIsError();

  return (
    <div className={`${classes.root} ${isError ? 'isError' : ''}`}>
      <SvgIcon component={WarningIcon} />
    </div>
  );
};

export default HeadCellAlerts;
